import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import projectsModel from '$$projectModel';
import timeTrackingModel from '$$timeTrackingModel';

export default function (task) {
  const taskLogsData = timeTrackingModel.getLogsByParamsNotCopy(task.gantt_id, task.id);
  // const taskResources = globalStore.getters['tasksModel/getResourcesForTask'](task.gantt_id, task.id);
  let result = 0;
  const projectAutoBudget = projectsModel.getProjectAutoBudget(task.gantt_id);

  if (projectAutoBudget) {
    if (taskLogsData) {
      _.each(taskLogsData.logs, log => {
        const resourceSettingsOnProject = globalStore.getters['resourcesModel/getResourceProjectSettings'](log.resource_id, task.gantt_id);

        if (!resourceSettingsOnProject) {
          return;
        }

        if (resourceSettingsOnProject.type === constants.RESOURCE_TIME_TYPE) {
          result += (log.time / 60) * resourceSettingsOnProject.cost;
        }
      });
    }

    if (!task.resources || !task.resources.length || !task.progress) {
      return result;
    }

    task.resources.forEach(resource => {
      const resourceSettingsOnProject = globalStore.getters['resourcesModel/getResourceProjectSettings'](resource.resource_id, task.gantt_id);

      if (!resourceSettingsOnProject) {
        return;
      }

      if (resourceSettingsOnProject.type === constants.RESOURCE_TIME_TYPE) {
        const resourceData = globalStore.getters['resourcesModel/getResourceById'](resource.resource_id);

        if (!resourceData.userId) {
          result += resource.value * resourceSettingsOnProject.cost * task.progress;
        }
      }

      if (resourceSettingsOnProject.type === constants.RESOURCE_ITEM_TYPE) {
        result += resource.value * resourceSettingsOnProject.cost * task.progress;
      }

      if (resourceSettingsOnProject.type === constants.RESOURCE_COST_TYPE) {
        result += resource.value * task.progress;
      }
    });
  } else {
    result += task.actual_cost || 0;
  }

  result = Math.round(result * 100) / 100;

  return result;
}
